import consumer from "./consumer"

window.initiateDemographicsUpdateChannel = function(surveyId, uploadUrl, file) {
  if (!surveyId || !file) return;

  const currentUser = window.dataLayer && window.dataLayer[0] ? window.dataLayer[0].userId : null;
  const element = (id) => document.getElementById(id);

  const escape = (text) => {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  };

  const fail = (message) => {
    element("update-demographics-progress-step").classList.add("d-none");
    element("update-demographics-error-message").textContent = message;
    element("update-demographics-error").classList.remove("d-none");
  };

  const subscription = consumer.subscriptions.create({
    channel: "SurveyResponseDemographicsChannel",
    survey_id: surveyId,
    requester_id: currentUser
  }, {
    async connected() {
      // Subscription confirmed — only now upload so the job's broadcast can't beat us to the stream.
      const token = document.querySelector("meta[name='csrf-token']")?.content;
      const body = new FormData();
      body.append("file", file);

      // No Content-Type header on purpose: the browser has to set the multipart boundary itself.
      const response = await fetch(uploadUrl, {
        method: "POST", credentials: "same-origin", body: body,
        headers: { "X-CSRF-Token": token, "Accept": "application/json" }
      });

      if (response.ok) return;

      // Nothing was enqueued, so no broadcast will ever arrive — surface the error here instead.
      const data = await response.json().catch(() => ({}));
      fail(data.error || "The file could not be processed.");
      subscription.unsubscribe();
    },
    received(data) {
      if (data.progress !== undefined) {
        const progressBar = element("update-demographics-progress");
        progressBar.style.width = `${data.progress}%`;
        progressBar.setAttribute("aria-valuenow", data.progress);
        element("update-demographics-progress-text").textContent = `${data.progress}%`;
      }

      if (data.done) {
        element("update-demographics-progress-step").classList.add("d-none");
        element("update-demographics-updated-count").textContent = data.updated;
        element("update-demographics-success").classList.remove("d-none");

        if (data.errors && data.errors.length) {
          element("update-demographics-skipped-count").textContent = data.skipped;
          element("update-demographics-errors-list").innerHTML = data.errors.map((e) => `<li>Row ${e.row}: ${escape(e.message)}</li>`).join("");
          element("update-demographics-errors-truncated").classList.toggle("d-none", !data.errors_truncated);
          element("update-demographics-errors").classList.remove("d-none");
        }
      }

      if (data.error) fail(data.error);
    }
  });

  $("#update-demographics-modal").on("hidden.bs.modal", function() {
    subscription.unsubscribe();
  });

  return subscription;
};
